export enum LISTENING_TYPE {
    DIALOG = 'dialog',
    TEXT = 'text',
}